<div _ngcontent-c0="" class="app-content ui basic segment container min">
  <div _ngcontent-c3="" class="ui basic segment wrapper">
    <div class="ui middle aligned center aligned grid">
      <div class="eight wide column">

        <h2 _ngcontent-c3="" class="ui image header center aligned">
          <div _ngcontent-c3="" class="content">
            Change Password
          </div>
        </h2>

        <form [formGroup]="changePasswordForm" (ngSubmit)="onSubmit()" _ngcontent-c3=""
              class="ui large form ng-pristine ng-invalid ng-touched" novalidate="" autocomplete="off">
          <div class="ui red message" *ngIf="(errorMsg != 'default')">
            {{ errorMsg }}
          </div>

          <div _ngcontent-c3="" class="ui segment">
            <div _ngcontent-c3="" class="field">
              <div _ngcontent-c3="" class="ui left icon input">
                <i _ngcontent-c3="" class="lock icon"></i>
                <input _ngcontent-c3="" formControlName="password" placeholder="Password" type="password">
                <div
                  *ngIf="(changePasswordFormControl.password.touched || submitted) && changePasswordFormControl.password.errors">
                  <div *ngIf="changePasswordFormControl.password.errors.required"
                       class="ui red left pointing prompt label transition visible">Password is required
                  </div>
                </div>
              </div>
            </div>
            <div _ngcontent-c3="" class="field">
              <div _ngcontent-c3="" class="ui left icon input">
                <i _ngcontent-c3="" class="lock icon"></i>
                <input _ngcontent-c3="" formControlName="confirmPassword" placeholder="Confirm Password"
                       type="password">
                <div
                  *ngIf="(changePasswordFormControl.confirmPassword.touched || submitted) && changePasswordFormControl.confirmPassword.errors">
                  <div *ngIf="changePasswordFormControl.confirmPassword.errors.required"
                       class="ui red left pointing prompt label transition visible">Confirm Password is required
                  </div>
                </div>
              </div>
            </div>
            <button [disabled]="(changePasswordForm.valid || loading) ? false : true" _ngcontent-c3=""
                    class="ui fluid large primary submit button">
              <i style="font-size:medium;" class="fa fa-spinner fa-spin" *ngIf="loading"></i>
              Change Password
            </button>
          </div>
        </form>

      </div>
    </div>

  </div>
</div>
